// AES 加密工具
import CryptoJS from "crypto-js";

const AES_KEY = "cNqU92BkNjPe74nY";

// === AES-CBC 加密 (与后端 decrypt_password 一致) ===
export function g7(e, t = AES_KEY) {
  // 生成 16 字节 IV
  const n = CryptoJS.lib.WordArray.random(16);

  // 密钥处理
  const key = CryptoJS.enc.Utf8.parse(t.slice(0, 32).padEnd(32, '0'));

  // AES-CBC 加密
  const encrypted = CryptoJS.AES.encrypt(e, key, {
    iv: n,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  // 拼接 IV + 密文
  const combined = n.concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(combined);
}

export async function encryptPassword(plaintext) {
  return g7(plaintext);
}
